import { FC } from 'react'
import { useTranslation } from 'react-i18next'

const PrivacyPolicy: FC = () => {
  const { t } = useTranslation()

  return (
    <main className="mx-auto w-full max-w-[60rem] px-4 py-10 md:py-16 text-ink">
      <h1 className="text-3xl md:text-4xl font-extrabold mb-6">{t('privacy.title')}</h1>
      <p className="text-base md:text-lg text-ink-2 mb-8">{t('privacy.placeholderNotice')}</p>
      <article className="prose max-w-none whitespace-pre-line">{t('privacy.body')}</article>
    </main>
  )
}

export default PrivacyPolicy
